import { onlyNumbers } from './string';
import { mask } from '../utils/mask';

export const maskPhoneNumber = (value?: string): string => {
  if (!value) return ``;

  const numbers = onlyNumbers(value.replace(`+55`, ``));

  if (numbers.match(/^[0-9]{10}$/)) {
    return mask(numbers, `(99) 9999-9999`);
  }
  if (numbers.match(/^[0-9]{11}$/)) {
    return mask(numbers, `(99) 99999-9999`);
  }

  return value;
};

/**
 * Separa um telefone brasileiro no formato que o PagSeguro espera no payload 3DS: DDD de
 * 2 dígitos e o número. Aceita valor mascarado e com +55 na frente. O emissor usa esses
 * dados na análise de risco da autenticação frictionless, então um DDD truncado reduz a
 * chance de autenticar.
 */
export const splitPhone = (value?: string | null): { area: string; number: string } => {
  const digits = onlyNumbers(value?.replace(`+55`, ``));

  return {
    area: digits.substring(0, 2),
    number: digits.substring(2),
  };
};
